import React, { useState, useEffect } from "react";
import { Tag, Button } from "antd";
import { SignalFilled } from "@ant-design/icons";

export const JobStatus = ({ name, statusId }) => {
  const [jobstatus, setJobstatus] = useState(statusId);
  const [fontcolor, setFontColor] = useState();

  useEffect(() => {
    switch (jobstatus) {
      case -2:
        setFontColor("red");
        break;
      case -1:
        setFontColor("red");
        break;
      case 1:
        setFontColor("#068a1a");
        break;
      case 2:
        setFontColor("#068a8a");
        break;
      case 3:
        setFontColor("#797a7a");
        break;
    }
  });

  return (
    <React.Fragment>
      <span
        style={{
          // minWidth: 100,
          textAlign: "center",
          color: fontcolor,
        }}
      >
        <SignalFilled /> {' '}
        {name ? name : null}
      </span>
    </React.Fragment>
  );
};
